import { render, staticRenderFns } from "./OrganizerSettingsPage.vue?vue&type=template&id=4a0f6bae&scoped=true"
import script from "./OrganizerSettingsPage.vue?vue&type=script&lang=js"
export * from "./OrganizerSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./OrganizerSettingsPage.vue?vue&type=style&index=0&id=4a0f6bae&prod&lang=scss"
import style1 from "./OrganizerSettingsPage.vue?vue&type=style&index=1&id=4a0f6bae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f6bae",
  null
  
)

export default component.exports